<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="贝展标题">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.title"
        ></a-input>
      </a-form-item>
      <a-form-item label="活动Logo">
        <UploadFile @callback="uploaded" :mult="false" folder="exhibition" />
      </a-form-item>
      <a-form-item label="活动海报">
        <UploadFile @callback="uploaded2" :mult="false" folder="exhibition" />
      </a-form-item>
      <a-form-item label="贝展简介">
        <a-textarea
          style="width: 600px"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
      <a-form-item label="选择位置">
        <a-button size="small" icon="compass" @click="pos_picker_show = true"></a-button>
        {{form.lat}}<span v-if="form.lng">,</span>{{form.lng}}
      </a-form-item>
      <a-form-item label="贝展场地">
        <a-input style="width: 600px" type="text" v-model="form.place"></a-input>
      </a-form-item>
      <a-form-item label="详细地址">
        <a-input style="width: 600px" type="text" v-model="form.addr"></a-input>
      </a-form-item>
      <a-form-item label="主办方">
        <a-input style="width: 600px" type="text" v-model="form.zhuban" placeholder="多个主办方用中文、隔开"></a-input>
      </a-form-item>
      <a-form-item label="协办方">
        <a-input style="width: 600px" type="text" v-model="form.xieban" placeholder="多个协办方用中文、隔开"></a-input>
      </a-form-item>
      <a-form-item label="贝展时间">
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.start_at" />
        <span style="margin: 0 10px">-</span>
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.end_at" />
      </a-form-item>
      <a-form-item label="详细介绍">
        <Editor
          @callback="updateEditor"
          :data="form.content"
          folder="exhibition"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">创建贝展</a-button>
    </div>

    <PosPicker v-if="pos_picker_show" @callback="gotPosition" />
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import UploadFile from "../../components/uploadFile";
import Editor from "../../components/editor";
import moment from 'moment';
import PosPicker from '../../components/posPicker';

export default {
  components: { UploadFile, Editor, PosPicker },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      form: {
        title: "",
        logo: "",
        thumb: "",
        desc: "",
        content: "",
        place: "",
        addr: '',
        lat: '',
        lng: '',
        zhuban: '',
        xieban: '',
        start_at: null,
        end_at: null
      },
      pos_picker_show: false
    };
  },
  methods: {
    moment,
    async sub() {
      const that = this;
      const r = await that.$axios.post("/exh/create", this.form);

      if (r.status == 1) {
        this.$router.push("/exh/list");
      }
    },

    uploaded(file) {
      this.form.logo = file.file_path;
    },

    uploaded2(file) {
      this.form.thumb = file.file_path;
    },
    
    updateEditor(data) {
      this.form.content = data;
    },

    gotPosition (pos) {
      this.pos_picker_show = false;
      this.form.place = pos.poiname;
      this.form.addr = pos.poiaddress;
      this.form.lat = pos.latlng.lat;
      this.form.lng = pos.latlng.lng;
    }
  },
};
</script>
